import { StreamingProvider } from 'components/machine/camera-stream-viewer/context';
import {
  IVccProps,
  VisionCalibrationCamera,
} from 'components/machine/dialogs/vision-calibration/camera';
import { MachineContext } from 'contexts/machine.context';
import { CameraSource } from 'lib_ts/enums/machine-msg.enum';
import { useContext } from 'react';

export const VisionCalibrationCameraHoC = (props: IVccProps) => {
  const { machine } = useContext(MachineContext);

  return (
    <StreamingProvider
      machineID={machine.machineID}
      hwVersion={machine.hardware_version}
      defaultSource={CameraSource.STEREO_CHECK}
    >
      <VisionCalibrationCamera {...props} />
    </StreamingProvider>
  );
};
